import { render, staticRenderFns } from "./AVehicleModelList.vue?vue&type=template&id=28cb73f0&scoped=true"
import script from "./AVehicleModelList.vue?vue&type=script&lang=js"
export * from "./AVehicleModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb73f0",
  null
  
)

export default component.exports